import { useMutation } from '@tanstack/react-query';

import { useInvalidateChannelsList } from '@/entities/channel';
import { useInvalidateChannelsOfCompanyList } from '@/entities/company';
import {
  addChannelToCompany as addChannelToCompanyApi,
  AddChannelToCompanyResponseDto,
} from '@/shared/api/companies';
import { useNotifications } from '@/shared/ui/Notifications';

interface IAddChannelToCompanyData {
  companyId: string;
  channelId: string;
}

export function useAddChannelToCompany() {
  const { addNotification } = useNotifications();
  const invalidateChannelsOfCompanyList = useInvalidateChannelsOfCompanyList();
  const invalidateChannelsList = useInvalidateChannelsList();
  const addChannelToCompanyMutation = useMutation({
    mutationFn: (data: IAddChannelToCompanyData) =>
      addChannelToCompanyApi(data.companyId, data.channelId),
  });

  const addChannelToCompany = async (
    data: IAddChannelToCompanyData,
    onCreate?: () => void
  ): Promise<AddChannelToCompanyResponseDto> => {
    return addChannelToCompanyMutation.mutateAsync(data, {
      onSuccess: async () => {
        onCreate?.();
        await Promise.all([
          invalidateChannelsOfCompanyList(data.companyId),
          invalidateChannelsList(),
        ]);
      },
      onError: (error) => {
        addNotification({
          title: error.message,
          caption: error?.data?.details,
        });
      },
    });
  };

  return {
    addChannelToCompany,
    ...addChannelToCompanyMutation,
  };
}
